export const OldPortfolioMessages = {
	fragmentsProceedsDestinationIban: {
		iban: "app.oldPortfolioState.error.fragmentsProceedsDestinationIban.invalid",
		required: "app.oldPortfolioState.error.fragmentsProceedsDestinationIban",
	},
	oldAccountNumber: {
		required: "app.oldPortfolioState.error.oldAccountNumber",
		oldAccountNumberEqualsNewAccountNumber:
			"app.oldPortfolioState.error.oldAccountNumberEqualsNewAccountNumber",
	},
	oldBankIdentifier: {
		invalidBankIdentifier: "app.oldPortfolioState.error.invalidBankIdentifier",
	},
	fragmentsProceedsDestinationBic: {
		bic: "app.oldPortfolioState.fragmentsProceedsDestinationBic.invalid",
		required: "app.oldPortfolioState.error.fragmentsProceedsDestinationBic",
	},
	fragmentsProceedsDestinationBankName: {
		required:
			"app.oldPortfolioState.error.fragmentsProceedsDestinationBankName",
	},
	fragmentsProceedsDestinationAccountOwner: {
		required:
			"app.oldPortfolioState.error.fragmentsProceedsDestinationAccountOwner",
	},
};



// WEBPACK FOOTER //
// ./src/app/components/oldPortfolio/oldPortfolio.constant.js